import React, { useState } from 'react';
import { Share2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { ShareModal } from './ShareModal';
import { ShareableContent } from '@/services/sharingService';
import { UserProfile } from '@/types';

interface ShareButtonProps {
  shareType: ShareableContent['type'];
  shareData: any;
  currentUser: UserProfile;
  className?: string;
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  text?: string;
}

export const ShareButton: React.FC<ShareButtonProps> = ({
  shareType,
  shareData,
  currentUser,
  className = '',
  variant = 'secondary',
  size = 'md',
  showText = true,
  text = 'Share'
}) => {
  const [showModal, setShowModal] = useState(false);

  const getButtonClasses = () => {
    const baseClasses = 'inline-flex items-center gap-2 font-medium transition-all duration-200 rounded-lg';
    
    const variantClasses = {
      primary: 'bg-cyan-600 hover:bg-cyan-500 text-white shadow-lg shadow-cyan-600/20',
      secondary: 'bg-gray-800 hover:bg-gray-700 text-gray-300 border border-gray-700',
      ghost: 'hover:bg-gray-800 text-gray-400 hover:text-gray-300'
    };

    const sizeClasses = {
      sm: 'px-3 py-1.5 text-sm',
      md: 'px-4 py-2 text-base',
      lg: 'px-6 py-3 text-lg'
    };

    return `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;
  };

  return (
    <>
      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={() => setShowModal(true)}
        className={getButtonClasses()}
      >
        <Share2 className={`${size === 'sm' ? 'w-4 h-4' : size === 'lg' ? 'w-6 h-6' : 'w-5 h-5'}`} />
        {showText && <span>{text}</span>}
      </motion.button>

      <ShareModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        shareType={shareType}
        shareData={shareData}
        currentUser={currentUser}
      />
    </>
  );
};